export const successConfigObj = {
    toastClass: "border-green"
}

export const errorConfigObj = {
    toastClass: "border-red",
}

export const infoConfigObj = {
    toastClass: "border-blue",
    timeOut: 6000
}